// extracted by mini-css-extract-plugin
export default {"add-item-card":"_10B62","addItemCard":"_10B62"};